import { api } from "../api/api";
import { KrogerInvoiceMockData } from "../util/mock-data/KrogerCreditInvoiceMockData";

const errorHandler = (error) => {
  if (error?.code?.trim() === "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const fetchProcessedData = async (params) => {
  try {
    const response = await api.post("/api/Invoices/Process", params);
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const sendProcessedData = async (params) => {
  try {
    const response = await api.post("/api/Invoices", params);
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

  export const getInvoiceDetails = async (params) => {
    try {
      const response = await api.get("/api/Invoices", { params });
      return response?.data?.result?.result || [];
    } catch (error) {
      errorHandler(error);
    }
  };
  export const getEdi894FileContent = async (params) => {
    try {
      const response = await api.get(`/api/Invoices/${ params?.id }/EDI894File/Content`);
      return response?.data?.result?.result || [];
    } catch (error) {
      errorHandler(error);
    }
  };